<template>

  <div>

    <!-- compact version (for smaller viewports) -->
    <div class="d-lg-none">
      <v-menu :close-on-content-click="false">

        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" :text="humanReadableModel" />
        </template>

        <v-date-picker
          :model-value="vuetifyModel"
          @update:model-value="foo"
          hide-header
          :first-day-of-week="1"
        />

      </v-menu>
    </div>

    <!-- full version (for larger viewports) -->
    <v-date-picker
      class="d-none d-lg-block"
      :model-value="vuetifyModel"
      @update:model-value="foo"
      hide-header
      :first-day-of-week="1"
    />

  </div>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Temporal } from '@js-temporal/polyfill'

const { t } = useI18n()

const model = defineModel<Temporal.PlainDate>({ required: true })

const vuetifyModel = computed<string>(() => {
  return model.value.toString()
})

function foo(newVuetifyValue: any) {

  let newValue

  if (newVuetifyValue instanceof Date) {
    newValue = new Temporal.PlainDate(newVuetifyValue.getFullYear(), newVuetifyValue.getMonth() + 1, newVuetifyValue.getDate())
  } else {
    console.error('newVuetifyValue:', newVuetifyValue)
    throw new Error('received an unexpected type for newVuetifyValue')
  }

  model.value = newValue

}

const humanReadableModel = computed<string>(() => {

  if (model.value === null) {
    return t('titles.select_date')
  }

  return model.value.toLocaleString()

})

</script>
